<ng-container *transloco="let t">
  <div class="p-dialog-with-toolbar common-lookup-dialog lookup-dialog-content" [ngClass]="lookupId">
    <div class="grid condensed-row">
      <div class="col-12 grid-table overflow-hidden">
        <z-order-inquiry-attachment-dialog-grid></z-order-inquiry-attachment-dialog-grid>
      </div>
    </div>

    <div class="p-dialog-footer p-dialog-footer-toolbar">
      <p-toolbar styleClass="dialog-toolbar">
        <div class="p-toolbar-group-left">
          <p-button
            label="{{ t('order.attachment_dialog.dialog.download') }}"
            styleClass="ml-1 p-button-danger"
            icon="far fa-download"
            [disabled]="downloadButtonDisabled$ | async"
            (click)="downloadAttachment()"
            [loading]="loading$ | async"
          ></p-button>
        </div>
        <div class="p-toolbar-group-right">
          <p-button
            label="{{ t('order.attachment_dialog.dialog.cancel') }}"
            styleClass="ml-1 p-button-secondary"
            (click)="close()"
          ></p-button>
        </div>
      </p-toolbar>
    </div>
  </div>
</ng-container>
